import { Box, Button } from '@mui/material';
import BirthdayScene from './BirthdayScene';

export interface BirthdayPerson { name: string; age?: number | null; }

const entrance = {
  '@keyframes bdayRise': {
    '0%': { transform: 'translateY(24px)', opacity: 0 },
    '100%': { transform: 'translateY(0)', opacity: 1 },
  },
  '@keyframes bdayNameGlow': {
    '0%, 100%': { textShadow: '0 0 16px rgba(255,255,255,0.4), 0 0 44px rgba(124,77,255,0.55)' },
    '50%': { textShadow: '0 0 26px rgba(255,255,255,0.7), 0 0 72px rgba(255,64,129,0.7)' },
  },
};

export default function BirthdayScreen({ people, onClose }: { people: BirthdayPerson[]; onClose: () => void }) {
  const solo = people.length === 1;

  return (
    <Box
      role="dialog" aria-label="Birthday celebration"
      sx={{
        position: 'fixed', inset: 0, zIndex: 2000, overflow: 'hidden',
        background: 'radial-gradient(circle at 50% 25%, #241540 0%, #130d26 55%, #0a0715 100%)',
        display: 'flex', flexDirection: 'column',
        ...entrance,
      }}
    >
      <BirthdayScene />

      <Box sx={{
        position: 'relative', zIndex: 1, flex: 1,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end',
        pb: { xs: 5, sm: 8 }, px: 2, textAlign: 'center', pointerEvents: 'none',
      }}>
        <Box sx={{
          display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'flex-start',
          gap: { xs: 3, sm: solo ? 0 : 7 }, maxWidth: 1000, mb: 4,
        }}>
          {people.map((p, i) => (
            <Box key={i} sx={{ animation: `bdayRise 0.7s ease-out ${0.3 + i * 0.12}s both`, minWidth: solo ? undefined : 220 }}>
              <Box sx={{
                color: '#fff', fontWeight: 800, lineHeight: 1.05, letterSpacing: 0.5,
                fontSize: solo ? { xs: 40, sm: 72 } : { xs: 30, sm: 46 },
                animation: 'bdayNameGlow 2.6s ease-in-out infinite',
              }}>
                {p.name}
              </Box>
              {p.age != null && p.age > 0 && (
                <Box sx={{ mt: 1, color: '#ffd740', fontWeight: 700, fontSize: solo ? { xs: 18, sm: 24 } : { xs: 15, sm: 18 } }}>
                  🎂 turning {p.age}
                </Box>
              )}
            </Box>
          ))}
        </Box>

        <Button
          variant="contained" size="large" onClick={onClose}
          sx={{
            pointerEvents: 'auto', px: 4, borderRadius: 999, textTransform: 'none', fontWeight: 700, fontSize: 18,
            background: 'linear-gradient(90deg, #ff4081, #7c4dff)',
            animation: 'bdayRise 0.7s ease-out 0.7s both',
            '&:hover': { background: 'linear-gradient(90deg, #ff5c95, #8a63ff)' },
          }}
        >
          Let&apos;s celebrate 🎉
        </Button>
      </Box>
    </Box>
  );
}
